import { apiClient } from '@/api/client'
import type { InviteUserRequest, UpdateUserRequest, UserListItem, UserListResponse, UserResponse } from '@/api/type'

/**
 * ログイン中のユーザー情報をバックエンドと同期
 */
export const syncUser = async (): Promise<UserResponse> => {
  const res = await apiClient.get(`/users/me`)
  return res.data
}

export type RouteRestoreCheck = {
  can_prompt: boolean
  /** ダイアログに出すページ名・作品名（分からなければ null） */
  label: string | null
  /** 作品ページのときだけ。/api を付けずに返る */
  thumbnail_url?: string | null
}

/** 再起動時に前回のページ (path) へ戻るか尋ねてよいか（Safe モードで隠すドメインは BE が false にする） */
export const checkRouteRestore = async (path: string): Promise<RouteRestoreCheck> => {
  // 起動直後に出すダイアログなので、遅い回線で後から出ないよう短めに打ち切る
  const res = await apiClient.get<RouteRestoreCheck>(`/users/me/route-restore`, {
    params: { path },
    timeout: 5_000,
  })
  return res.data
}

/**
 * 全ユーザー一覧を取得（管理者のみ）
 */
export const getAllUsers = async (): Promise<UserListResponse> => {
  const res = await apiClient.get(`/users`)
  return res.data
}

/**
 * ユーザー権限を更新（管理者のみ）
 */
export const updateUser = async (userId: string, request: UpdateUserRequest): Promise<UserListItem> => {
  const res = await apiClient.patch(`/users/${userId}`, request)
  return res.data
}

/**
 * ユーザーを招待（事前登録）する（管理者のみ）
 * 本人が同じメールの Google アカウントでサインインすると、このユーザーとしてログインできる
 */
export const inviteUser = async (request: InviteUserRequest): Promise<UserListItem> => {
  const res = await apiClient.post(`/users/invite`, request)
  return res.data
}

/**
 * ユーザーを削除（管理者のみ）
 */
export const deleteUser = async (userId: string): Promise<{ message: string; deleted_user_id: string }> => {
  const res = await apiClient.delete(`/users/${userId}`)
  return res.data
}
